import type { NavLink } from '../model/types';

import style from '../ui/styles.module.pcss';

export const MENU_LINKS: NavLink[] = [
  { name: 'Найти реплей', link: '/find-replay' },
  { name: 'Конкурсы', link: '/contest' },
];

export const RIGHT_PANEL_LINKS: NavLink[] = [
  {
    name: 'Загрузить реплей',
    link: '/replay/upload',
    class: 'button secondary upload',
  },
  {
    name: 'Мои реплеи',
    link: '',
    liLink: 'h-100',
    class: `account ${style['menu-item']} uppercase h-100`,
    withDogtag: true,
    private: true,
  },
];
